import type { VFC } from 'react';

import { fetcherToPlainText } from '../../../shared/fetchers';

import FetcherIcon from './FetcherIcon';
import Flex from './Flex';

export type FetcherDetailProps = {
  fetcher: string;
};

/** Shows the fetcher name along with it's icon. */
const FetcherDetail: VFC<FetcherDetailProps> = ({ fetcher }) =>
  // We want this box to stay tight to the content, so we set shrink and grow to zero.
  <Flex direction="row" gap="0" shrink="0" grow="0" align="center" justify="flex-start" wrap="nowrap">
    <FetcherIcon fetcher={fetcher} />
    <span className="margin-left-xs">
      {fetcherToPlainText(fetcher)}
    </span>
  </Flex>;

export default FetcherDetail;
